import { Pipe, PipeTransform } from '@angular/core';
import { FilterSubsListObj } from 'src/app/models/filter-list-model';

@Pipe({ name: 'msFilterSearch', pure: false })
export class MsFilterSearchPipe implements PipeTransform {
  transform(items: FilterSubsListObj[], query: string): FilterSubsListObj[] {
    if (!query?.trim()) return items;
    const q = query.toLowerCase();
    return items.filter(i => i.value?.toLowerCase().includes(q));
  }
}
